import { render, staticRenderFns } from "./PeriodicNameList.vue?vue&type=template&id=bce181bc&"
import script from "./PeriodicNameList.js?vue&type=script&lang=js&"
export * from "./PeriodicNameList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports